









import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { UnitDefinition } from '@/services/ProductDeserializer';

@Component
export default class UnitSelector extends Vue {
  @Prop({ required: true })
  public units: UnitDefinition[];

  @Prop({ required: false })
  public width: string;

  @Model('select', { required: false })
  public selectedUnit?: UnitDefinition;

  public isSelected(unit: UnitDefinition) {
    return this.selectedUnit.abbreviation === unit.abbreviation;
  }

  public selectUnit(unit: UnitDefinition) {
    this.$emit('select', unit);
  }

  public mounted() {
    this.units.sort((a, b) => a.ratio - b.ratio);
  }
}
